export type DateRangeGranularityType = 'date-only' | 'date-and-time';
export type DateRangeIntervalPartType = 'from' | 'to';

export const INFINITY_SYMBOL = '∞';